import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: 'This seems expensive. Why not use a $500 template?',
  answer: "A $500 template looks like a $500 template. It signals to high-ticket clients that you cut corners. We build custom architectures optimized for speed, SEO, and conversions, paired with authority-positioning content. You're not buying a website; you're investing in an asset that generates ROI."
}, {
  question: "What's the typical timeline?",
  answer: 'Core web architecture (The Presence) typically takes 4-8 weeks from kickoff to launch. Content cycles and full digital transformations are ongoing partnerships, with initial deliverables rolling out in the first 30 days.'
}, {
  question: 'How do I measure ROI?',
  answer: "We implement comprehensive tracking from day one. You'll get access to performance dashboards monitoring site speed, user engagement, conversion rates, and content metrics. We focus on metrics that impact your bottom line, not vanity numbers."
}, {
  question: 'What makes PCS different from other agencies?',
  answer: "Most agencies either build pretty sites that don't convert, or write copy for ugly sites. We fuse elite engineering (architecture) with premium storytelling (content). Zero fluff, no junior account managers, just direct access to senior strategists and results-driven execution."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 md:py-32 bg-[#0A0A0A]" data-id="element-106">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-108">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-109">
            Objections, Handled.
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-110">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-white/10 rounded-sm overflow-hidden bg-[#111111]" data-id="element-111">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-112">
                <span className="font-display text-lg font-medium text-white pr-8" data-id="element-113">
                  {faq.question}
                </span>
                <span className="text-neutral-400 shrink-0" data-id="element-114">
                  {openIndex === index ? <Minus size={20} data-id="element-115" /> : <Plus size={20} data-id="element-116" />}
                </span>
              </button>

              <AnimatePresence data-id="element-117">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-118">
                    <div className="p-6 pt-0 text-neutral-400 leading-relaxed border-t border-white/5 mt-2" data-id="element-119">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}